import {Banks} from './banks';
import {Wallets} from './wallets';
import {Coin, RangeLimit} from './prices';
import {Authenticator} from './authentication';

export type UserGender = 'male' | 'female';
export type UserRole = 'user' | 'admin';
export type UserStar = 0 | 1 | 2 | 3 | 4 | 5;
export type UserVerificationStatus =
  | 'CREATED'
  | 'CONTACT_VERIFIED'
  | 'IDENTITY_VERIFIED'
  | 'ID_CARD_REJECTED'
  | 'ID_CARD_VERIFIED'
  | 'SELFI_REJECTED'
  | 'PROCESSING'
  | 'REJECTED'
  | 'VERIFIED';

export interface UserStarsData extends RangeLimit {
  off: number;
  star: UserStar;
  latestCalculate: string;
}

export interface UserCoinData {
  coin: Coin['id'];
  amount: number;
  amountBlocked: number;
}

export interface UserAddress {
  country: string;
  county: string;
  city: string;
  line: string;
  zip: string;
}

export interface User {
  mobile: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  gender: UserGender;
  idNo: string;
  phone: string;
  email: string;
  balance: number;
  balanceBlocked: number;
  verifyAt: string;
  role: UserRole;
  address: UserAddress;
  avatar: string | null;
  authenticator: Authenticator | null;
  wallets: Wallets[];
  banks: Banks[];
  stars: UserStarsData;
  coins: UserCoinData[];
}

export enum UserStarsAlias {
  Initial = 'بدون سطح',
  First = 'سطح پایه',
  Second = 'سطح عمومی',
  Third = 'سطح نقره‌ای',
  Fourth = 'سطح طلایی',
  Fifth = 'سطح دایموند'
}
